export default function SNSCommunity() {
  const platforms = [
    {
      name: 'Instagram',
      handle: '@bts_staygold_7',
      url: 'https://www.instagram.com/bts_staygold_7/',
      icon: 'ri-instagram-fill',
      description: '50代以上の女性層へ「旅と韓国」の魅力を視覚的に発信。アクティブで熱量の高い層と深く繋がっています。',
      color: 'from-pink-500 to-purple-600'
    },
    {
      name: 'TikTok',
      handle: '@ayakokikuta',
      url: 'https://www.tiktok.com/@ayakokikuta',
      icon: 'ri-tiktok-fill',
      description: '動画による「韓国語学習」や「聖地巡礼」の魅力を発信。ショート動画の拡散力を活かし、潜在的な旅行検討層へダイレクトにリーチします。',
      color: 'from-gray-800 to-gray-900'
    },
    {
      name: 'オンラインサロン',
      handle: 'DMMオンラインサロン',
      url: 'https://lounge.dmm.com/detail/5350',
      icon: 'ri-group-fill',
      description: '「募集開始1日で完売」を生み出す集客の核。信頼関係が構築されたクローズドなコミュニティにより、確実な送客と高い満足度を実現します。',
      color: 'from-[#1e3a8a] to-[#3b82f6]'
    }
  ];

  return (
    <section className="py-20 sm:py-24 lg:py-28 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* セクションヘッダー */}
        <div className="text-center mb-16 sm:mb-20">
          <div className="inline-block mb-5 sm:mb-7">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              SNS &amp; Community Presence
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-5 sm:mb-7 leading-tight px-4">
            ターゲット層と直接つながる発信基盤
          </h2>
        </div>

        {/* カードグリッド */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
          {platforms.map((platform, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col"
            >
              {/* アイコンヘッダー */}
              <div className={`bg-gradient-to-br ${platform.color} p-8 sm:p-10 flex items-center justify-center`}>
                <div className="w-24 h-24 sm:w-28 sm:h-28 flex items-center justify-center">
                  <i className={`${platform.icon} text-7xl sm:text-8xl text-white`}></i>
                </div>
              </div>

              {/* コンテンツ */}
              <div className="p-6 sm:p-8 flex flex-col flex-grow">
                <h3 className="text-xl sm:text-2xl font-bold text-[#1e3a8a] mb-2">
                  {platform.name}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4">
                  {platform.handle}
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-6 flex-grow">
                  {platform.description}
                </p>

                {/* ボタン */}
                <a
                  href={platform.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-[#1e3a8a] text-white px-6 py-3 rounded-lg font-semibold text-sm sm:text-base hover:bg-[#2c5aa0] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <span>アカウントを見る</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}